import { Outlet } from "react-router-dom"
const MainPattyCashExpense = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainPattyCashExpense;